<template>
    <div>

   <div class="overlay" v-if="crmFieldSelect" @click="crmFieldSelect = false"></div>
     <div id="rcorners" class="modal" v-if="crmFieldSelect">
        <!-- <div class="custom-row">
        <div class="custom-column" >
            <h2 >Table Attributes</h2>
            <br>
            <ul>
                <li><label class="container-checkbox"><input type="checkbox" :checked="isAllSelected" @click="selectAllAttributes">Select All <span class="checkmark"></span></label></li>
                <li v-for="(item,id) in crmSenderAttributes" :key="id">
                <label class="container-checkbox"><input type="checkbox" v-model="selectedTableAttributes"  :value="item.value" @change="select(item.value)">{{item.text}} <span class="checkmark"></span></label></li>
            </ul>
        </div>
        <div class="custom-column" >
            <h2>Filter Attributes</h2>
            <br>
             <ul>
                <li><label class="container-checkbox"><input type="checkbox" :checked="isAllFilterSelected" @click="selectAllFilterAttributes">Select All <span class="checkmark"></span></label></li>
                <li v-for="(item,id) in selectedTableAttributes" :key="id">
                <label class="container-checkbox"><input type="checkbox" v-model="selectedFilterAttributes" :value="item" @change="selectFilter">{{item}} <span class="checkmark"></span></label></li>
            </ul>
        </div> -->
                    <h2 style="  text-align: center;">{{this.$t("crmAttibutesSettings")}}</h2>
        <br>
        <div class="container">
            <div class="custom-row">
                <div class="col-12 tableFixHead">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col" style="width:50%">{{this.$t("crmAttributes")}}</th>
                        <th scope="col"> <label class="container-checkbox"><input type="checkbox" :checked="isAllSelected" @click="selectAllAttributes">{{this.$t("displayInTable")}}</label></th>
                        <th scope="col"><label class="container-checkbox"><input type="checkbox" :checked="isAllFilterSelected" @click="selectAllFilterAttributes">{{this.$t("allowToFilter")}}</label></th>
                    </tr>
                    </thead>
                    <tbody >
                    <tr v-for="(item,id) in crmSenderAttributes" :key="id">
                        <td>
                            {{item.text}}
                        </td>
                        <td style=" text-align: center; vertical-align: middle;">
                            <label class="container-checkbox"><input type="checkbox" v-model="selectedTableAttributes"  :value="item.value" @change="select(item.value)"> <span class="checkmark" style="left:42%"></span></label>
                        </td>
                        <td style=" text-align: center; vertical-align: middle;">
                            <label v-if="selectedTableAttributes.includes(item.value)" class="container-checkbox"><input type="checkbox" v-model="selectedFilterAttributes" :value="item.value" @change="selectFilter"> <span class="checkmark" style="left:42%"></span></label>
                        </td>

                    </tr>

                    </tbody>
                </table>
                </div>
            </div>
        </div>
        <br>
        <v-btn style="float: right" color="primary" @click="selectAttributes" >{{this.$t("save")}}</v-btn>
        <v-btn style="float: right" color="white" @click="cancel" >{{this.$t("cancel")}}</v-btn>
    </div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">{{$t('senderList')}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="pa-1">
                <v-btn color="primary" @click="getCrmSchema">{{this.$t("crmAttibutesSettings")}}</v-btn>
                <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report" style="float:right" >Export Excel</v-btn>
                <v-btn color="primary" @click="getCrmData">{{this.$t("searchSender")}}</v-btn>
                <v-btn @click="clearAllFilters">{{this.$t("clearAllFilters")}}</v-btn>
                    <v-form
      ref="form">
      <v-layout class="d-none">
                    <v-flex xs4>
                        <v-select
                                v-model="channel"
                                label="Channel"
                                :items="channelList"
                                disabled
                        />
                    </v-flex>
                    <v-spacer/>
                </v-layout>
                <v-layout class="filter">
                    <v-flex xs4>
                        <v-select
                                v-model="channel"
                                label="Channel"
                                :items="channelList"
                                @change="getCrmData"
                        />
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field
                                v-model="senderNameFilterValue"
                                label="Sender Name"
                                placeholder="Sender Name"
                                clearable
                                v-on:keyup.enter="getCrmData"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <v-select
                                v-model="interval"
                                label="Last Interactive Time"
                                :items="intervalList"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="fromDate"
                                label="From Date"
                                @input="handleFromDateChange"
                                :max="toDate"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="toDate"
                                label="To Date"
                                @input="handleToDateChange"
                                :min="fromDate"
                                :max="today"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>

                        <v-flex xs4 v-for ="(filter,i) of filterHeader" :key="filter.value">

                        <v-text-field
                                class="filter-value"
                                v-model="crmFilterValue[i]"
                                v-show="i<0||showAllFilters"
                                v-bind:label="filter.text"
                                v-bind:placeholder="filter.text"
                                clearable
                                v-on:keyup.enter="getCrmData"
                        />
                         </v-flex>


                </v-layout>
      </v-form>


                <div v-if="selectedFilterAttributes.length>0" class="text-xs-center">
                <!-- <p v-if="!showAllFilters" @click="showAllFilters=true">Show all filters</p> -->
                <a v-if="!showAllFilters" @click="showAllFilters=true" href="#" class="action_more more_less_action btn">{{this.$t("showAllFilters")}}</a>
                <a v-else @click="showAllFilters=false" href="#" class="action_more more_less_action btn">{{this.$t("hideFilters")}}</a>
                <!-- <p v-else @click="showAllFilters=false">Hide filters</p> -->
                </div>
            </v-card>
            <v-card class="my-3">
                <v-data-table
                        :items="dataTableSort"
                        :headers="headers"
                        :pagination.sync="pagination"
                        :total-items="total_reports"
                        :rows-per-page-items="rowsPerPageItems"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value">
                                <span v-if="header.$value">
                                    <span v-if="header.value == 'sender_id'">
                                    <a target="_blank" :href="`/bot/${activeBot.code}/s/${header.$value(props.item)}`">{{header.$value(props.item)}}</a>
                                    </span>
                                    <span v-else>
                                    {{header.$value(props.item)}}
                                    </span>
                                </span>
                                <span v-else>{{props.item[header.value]}}</span>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:headers="props">
                        <tr>
                            <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="[
                                        'column sortable',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.value === pagination.sortBy ? 'active' : ''
                                    ]"
                                    @click="changeSort(header.value)"
                            >
                                <v-layout align-center style="height: 25px">
                                    <span>{{header.text}}</span>
                                    <v-menu open-on-hover bottom offset-y left v-if="header.tooltips">
                                        <template v-slot:activator="{ on }">
                                            <i class="mdi mdi-alert-circle info-icon ml-1" v-on="on"></i>
                                        </template>
                                        <div class="header-tooltips">
                                            <v-layout align-start>
                                                <v-icon small dark color="#4977EE" class="mr-1">
                                                    mdi-alert-circle
                                                </v-icon>
                                                {{header.tooltips}}
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Max</div>
                                                <div>{{max[header.value]}}</div>
                                            </v-layout>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Min</div>
                                                <div>{{min[header.value]}}</div>
                                            </v-layout>
                                        </div>
                                    </v-menu>
                                    <v-icon small>mdi-arrow-up</v-icon>
                                </v-layout>
                            </th>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import ReportService from '@/services/report.service'
import _ from 'lodash'
import moment from 'moment'
import DatePicker from '@/components/custom/DatePicker'
import BotService from '@/services/bot.service'
import {SocketMixin} from "@/mixins/SocketMixin";
import {mapActions, mapState} from "vuex";
import CustomerService from "@/services/customer.service";
import utils from "@/services/utils";
import ActionTypes from "@/store/ActionTypes";
import StaffService from "@/services/staff.service";
export default {
        name: 'Sender',
        components: {DatePicker},
        mixins: [SocketMixin],
        data() {
            return {
                // supporterEmail: '',
                fromDate: moment().subtract(29, 'day').format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
                today: moment().format('YYYY-MM-DD'),
                supporter: 'all',
                channel: 'all',
                interval: '30days',
                activeBot: {},
                dataTable: [],
                senderNameFilterValue:'',
                isAllSelected:false,
                isAllFilterSelected:false,
                total_reports: 0,
                intervalList: [
                    {text: 'Last 30 days', value: '30days'},
                    {text: 'Last 90 days', value: '90days'},
                    {text: 'Custom', value: 'custom'}
                ],
                crmSenderAttributes:[],
                crmHeaders:[],
                filterHeader:[],
                crmFilterValue:[],
                selectedTableAttributes:[],
                selectedFilterAttributes:[],
                crmFieldSelect: false,
                showAllFilters: true,
                min: {},
                max: {},
                is_lock_report: false,
                channelList: [
                    {text: 'All', value: 'all'},
                ],

                pagination: {

                },
                rowsPerPageItems: [ 20, 50, 70, 100 ],
                loadingDialog: false,
                botList: [],
                crm_fields: [],
                collections: {},
                max_level: 0,
                headers_const: [
                    {
                        text: 'No',
                        value: 'index',
                        sortable: true
                    },
                    {
                      text: 'Sender Id',
                      value: 'sender_id',
                      $value: item => item.sender_id,
                      sortable: true
                    },
                    {
                        text: 'Sender Name',
                        value: 'sender_name',
                        $value: item => item.sender_name,
                        // filter: this.nameFilter,
                        sortable: true
                    },
                    {
                        text: 'Channel',
                        value: 'channel',
                        $value: item => this.channelFormat(item.channel),
                        sortable: true
                    },
                    {
                        text: 'Last Interactive Time',
                        value: 'last_user_interactive_time',
                        $value: item =>item.last_user_interactive_time ? this.dateFormat(item.last_user_interactive_time) : "",
                        sortable: true
                    },
                    ],
                headers: []
            }
        },
        computed: {
            ...mapState(['notifyBotChat', 'user']),
            isValidTimeRangeFilter() {
                return moment.utc(this.toDate).diff(this.fromDate, 'days')  <= 90;
            },
            dataTableSort() {
                let clone = []
                if (this.dataTable.length) {
                    clone = [...this.dataTable]
                    clone = clone.map((items, index) => ({...items, index:  index + this.pagination.rowsPerPage*(this.pagination.page-1) + 1}))
                } else {
                    return []
                }
                if (this.pagination.sortBy) {
                    let header = _.find(this.headers, item => item.value === this.pagination.sortBy)
                    if(header){
                        return _.orderBy(
                            clone,
                            item => header.$value ? header.$value(item) : item[header.value],
                            this.pagination.descending ? 'desc' : 'asc'
                        )
                    }
                }
                return clone
            }
        },
        mounted() {   
            if(this.hasPermission()){
                this.loadingDialog = true
                this.getListChannels()
                BotService.getAllBot().then(
                    result => {
                        this.botList = result.data;
                        let botCode = this.$route.params.botCode
                        if (botCode) {
                            let bot = _.find(this.botList, bot => bot.code === botCode)
                            if (bot) {
                                this.selectBot(bot)
                            } else {
                                this.loadingDialog = false
                                this.$router.push('/sender')
                            }
                        } else if (this.botList.length > 0) {
                            this.selectBot(this.botList[0])
                        } else {
                            this.loadingDialog = false
                        }
                    },
                ).catch(()=>{
                    this.$AppService.handleRequestError('can not get bot list')
                });
            }
            else{
                this.$router.push('/forbidden')
            }
            
        },
        methods: {
          ...mapActions('notify',['notifyCustomerProcess']),
            // nameFilter($value) {
            //     // If this filter has no value we just skip the entire filter.

            //     if (!this.senderNameFilterValue) {
            //     return true;
            //     }

            //     // Check if the current loop value (The sender name)
            //     // partially contains the searched word.
            //     return $value.toLowerCase().includes(this.senderNameFilterValue.toLowerCase());
            // },
            hasPermission(){
                return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
            },
            async clearAllFilters() {
                //console.log(this.crmFilterValue)
                this.$refs.form.reset()
                //this.crmFilterValue=[]
                this.getCrmData()
            },
            getCrmSchema() {
                this.crmFieldSelect = true
                this.crmSenderAttributes =[]
                let attributes = this.collections.attributes ? Object.keys(this.collections.attributes) : []
                for (const key in attributes){
                    this.crmSenderAttributes.push({ id: key, text: attributes[key], value: attributes[key] })
                }
                if (this.selectedTableAttributes.length == this.crmSenderAttributes.length && this.selectedTableAttributes.length != 0){
                    this.isAllSelected = true
                }else{
                    this.isAllSelected = false
                }
                if (this.selectedTableAttributes.length == this.selectedFilterAttributes.length && this.selectedFilterAttributes.length != 0){
                    this.isAllFilterSelected = true
                }else{
                    this.isAllFilterSelected = false
                }
            },
            selectAllAttributes() {
            if (this.isAllSelected) {
                this.selectedTableAttributes = []
                this.selectedFilterAttributes = []
                this.isAllSelected = false
                this.isAllFilterSelected = false
            } else {
                this.selectedTableAttributes = []
                for (var att in this.crmSenderAttributes) {
                this.selectedTableAttributes.push(this.crmSenderAttributes[att].value)
                }
                this.isAllSelected = true
            }
            },
            selectAllFilterAttributes() {
            if (this.isAllFilterSelected) {
                this.selectedFilterAttributes = []
                this.isAllFilterSelected = false
            } else {
                this.selectedFilterAttributes = []
                for (var att in this.selectedTableAttributes) {
                this.selectedFilterAttributes.push(this.selectedTableAttributes[att])
                }
                this.isAllFilterSelected = true
            }
            },
            select(value) {
                this.selectedFilterAttributes = this.selectedFilterAttributes.filter(function(item){
                    return item != value;
                });

                if (this.selectedTableAttributes.length == this.crmSenderAttributes.length && this.selectedTableAttributes.length != 0) {
                    this.isAllSelected = true
                } else {
                    this.isAllSelected = false
                }
                this.selectFilter()
            },
            selectFilter(){
                if (this.selectedFilterAttributes.length == this.selectedTableAttributes.length && this.selectedFilterAttributes.length != 0) {
                    this.isAllFilterSelected = true
                } else {
                    this.isAllFilterSelected = false
                }
            },
            async cancel(){
                this.crmFieldSelect = false
                this.getSenderListConfig()
            },
            handleFromDateChange() {
                if (!this.isValidTimeRangeFilter) {
                    const maxAllowedToDate = moment.utc(this.fromDate).add(90, 'days');
                    this.toDate = maxAllowedToDate.toISOString().substr(0, 10);

                }

            },
            handleToDateChange() {
                if (!this.isValidTimeRangeFilter ) {
                    const minAllowedFromDate = moment.utc(this.toDate).subtract(90, 'days');
                    this.fromDate = minAllowedFromDate.toISOString().substr(0, 10);

                }
            },
            async getData() {
                if(!this.isValidTimeRangeFilter) {
                    this.$AppService.toastError(this.$t("excessMaximumExportLimit"));
                    return
                }
                if (this.activeBot.code) {
                    let headers = [...this.headers_const, ...this.crmHeaders];

                    let listHearder = []
                    for(const header in headers){
                        listHearder.push(headers[header].value)
                    }
                    let properties = {
                            sender_name: this.senderNameFilterValue ? this.senderNameFilterValue :"",
                            channel: this.channel == "all" || !this.channel ? "" : this.channel
                    }
                    for (const headers in this.filterHeader){
                        properties[this.filterHeader[headers].value]= this.crmFilterValue[headers]? this.crmFilterValue[headers].toString():""
                    }
                    this.loadingDialog = true
                    Promise.all([
                        CustomerService.getCrmCustomers(
                            this.$route.params.botCode,
                            properties,//properties
                            // this.channel, //channel
                            listHearder, //projection
                            this.pagination.page,
                            this.pagination.rowsPerPage,
                            this.toISOString(this.fromDate, true),
                            this.toISOString(this.toDate),
                        )

                    ])
                        .then(result => {
                            this.dataTable = result[0].data.data
                            this.loadingDialog = false
                            this.total_reports = result[0].data.pagination.total;
                            this.max_level = result[0]['data'].max_level;
                            this.headers = [...this.headers_const, ...this.crmHeaders];

                            // let dataCRM = result[1].data.data
                            // for (const item in this.dataTable ){
                            //     let senderMap = dataCRM.find(element => element.sender_id == this.dataTable[item]._id.sender_id)
                            //     if (senderMap){
                            //         this.dataTable[item] = {...this.dataTable[item], ...senderMap}
                            //     }
                            // }
                        }, () => {
                            this.$AppService.handleRequestError('can not get session info data')
                            this.loadingDialog = false
                        })

                }

            },
            async selectAttributes(){
                let config = {
                    selected_crm_attributes : this.selectedTableAttributes,
                    selected_sender_filter_attributes : this.selectedFilterAttributes
                }
                let backend_response = await BotService.updateBotSelectedCRMAttributes(this.$route.params.botCode, config)
                if (backend_response.status == 200) {
                    this.$AppService.toastSuccess(this.$t("saveSelectedCRMAttributesSuccess"))
                }else {
                    this.$AppService.toastError(this.$t("saveSelectedCRMAttributesFailed"));
                }
                this.getCrmData()
            },
            async getCrmData(){
                this.crmHeaders = []
                for(const attribute in this.selectedTableAttributes){
                    let title = this.stringFormat(this.selectedTableAttributes[attribute])
                    this.crmHeaders.push({
                        text: title,
                        value: this.selectedTableAttributes[attribute],
                        sortable: true
                    },)
                }
                this.filterHeader = []
                for(const attribute in this.selectedFilterAttributes){
                    let title = this.stringFormat(this.selectedFilterAttributes[attribute])
                    this.filterHeader.push({
                        text: title,
                        value: this.selectedFilterAttributes[attribute],
                        sortable: true
                    },)
                }

                await this.getData()
                this.crmFieldSelect = false
            },
            calculateValue(item, i) {
              if (typeof item.topic === 'string' && i<0) {
                  return item.topic
              }
              else if (!!item.topic && typeof item.topic === 'object') {
                  return item.topic[`level_${i+1}`]
              }
              else {
                  return "";
              }
            },
            toISOString(date, startOfDay) {
                return startOfDay ? moment.utc(date).startOf('day').toISOString() : moment(date).endOf('day').toISOString()
            },
            dateFormat(date) {
                let formatedDate = moment.utc(date).utcOffset(7).format('DD-MM-YYYY HH:mm:ss')
                let momentDate = moment.utc(formatedDate,'DD-MM-YYYY HH:mm:ss')
                return momentDate.isValid() ? formatedDate : ""
            },
            channelFormat(channel){
                return this.stringFormat( this.$t(channel))
            },
            stringFormat(string){
                if(string){
                    string = string.split("_");
                    for (var i = 0, x = string.length; i < x; i++) {
                                string[i] = string[i][0].toUpperCase() + string[i].substr(1);
                    }
                    string = string.join(" ");
                }

                return string
            },
            getListChannels() {
                BotService.getListChannels(this.$route.params.botCode).then((list_channels) => {
                    this.channelList = utils.smoothListChannels(list_channels.data.channels);
                    for(const channel in this.channelList){
                        this.channelList[channel] = {text: this.channelFormat(this.channelList[channel]), value: this.channelList[channel]}
                    }
                });
            },
            changeBot(bot) {
                this.crmHeaders = []
                // this.selectedTableAttributes = []
                this.isAllSelected = false
                this.botCode = bot.code
                this.is_lock_report = false
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/sender/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot
                this.getSenderListConfig()
            },
            changeSort(headerValue) {
                let pagination = {...this.pagination}
                if (pagination.sortBy === headerValue) {
                    pagination.descending = !this.pagination.descending
                } else {
                    pagination.sortBy = headerValue
                    pagination.descending = true
                }
                this.pagination = pagination
                setTimeout(() => {
                    this.$forceUpdate()
                }, 2000)
            },
            async exportExcel() {
                let listHearder = []
                    for(const header in this.headers){
                        listHearder.push(this.headers[header].value)
                    }
                let properties = {
                        sender_name: this.senderNameFilterValue,
                        channel: this.channel == "all" || !this.channel ? "" : this.channel
                    }
                for (const headers in this.filterHeader){
                    properties[this.filterHeader[headers].value]= this.crmFilterValue[headers]? this.crmFilterValue[headers].toString():""
                }
                ReportService.SenderExcel(this.activeBot.code, properties, listHearder, this.toISOString(this.fromDate, true), this.toISOString(this.toDate))
                    .then(() => {
                        this.$AppService.toastSuccess(this.$t("reportSuccess"))
                        this.is_lock_report = true
                    }).catch(()=> {
                        this.$AppService.toastError(this.$t("reportFailed"));
                    });
            },
            getSenderListConfig() {
                let botCode = this.$route.params.botCode;
                Promise.all([
                    // BotService.getSessionReportConfig(botCode),
                    BotService.getCRMCollection(botCode),
                    BotService.getBotSelectedCRMAttributes(botCode)
                ])
                    .then((values)=>{
                    //  this.crm_fields = values[0].data.config_data;
                     this.collections = values[0].data;
                    //   console.log(JSON.parse(values[1].data.selected_crm_attributes))
                    this.selectedTableAttributes = JSON.parse(values[1].data.selected_crm_attributes)
                    this.selectedFilterAttributes = JSON.parse(values[1].data.selected_sender_filter_attributes)
                    let attributes = this.collections.attributes ? Object.keys(this.collections.attributes) : []
                    this.selectedFilterAttributes = this.selectedFilterAttributes.filter(function(item){
                        return attributes.includes(item);
                    });
                    this.selectedTableAttributes = this.selectedTableAttributes.filter(function(item){
                        return attributes.includes(item);
                    });
                    // _.mapKeys(this.collections.built_in, (value, key)=>{
                    //         this.headers_const.push({
                    //             text: key,
                    //             value: `customer_attributes.built_in.${key}`,
                    //             $value: item => item.customer_attributes && item.customer_attributes.built_in ? item.customer_attributes.built_in[key]: '',
                    //         })
                    // });
                    // _.mapKeys(this.collections.attributes, (value, key)=>{
                    //             this.headers_const.push({
                    //                 text: key,
                    //                 value: `customer_attributes.attributes.${key}`,
                    //                 $value: item => item.customer_attributes && item.customer_attributes.attributes ? item.customer_attributes.attributes[key]: '',
                    //             })
                    //     })
                }).then(()=> {
                    this.getCrmData()
                })
            },
          connectNotiChannelsOfBot(bot_code) {
            // connect channels notification of bot
            // check if subscribed, > unsubscribe
            if (this.$store.state.channelsNotiBot && this.$store.state.channelsNotiBot.state && this.$store.state.channelsNotiBot.state === "subscribed") {
              this.$store.state.channelsNotiBot.unsubscribe();
            }
            // connect channels notification
            let noti_bot_channel_name = this.$const.SOCKETCLUSTER_NOTI_CHANNEL.APP + bot_code;
            this.$store.state.channelsNotiBot = this.$store.state.scClient.subscribe(noti_bot_channel_name);
            this.$nextTick(function () {
              this.$store.state.channelsNotiBot.watch(data => {
                this.$store.commit(this.$ActionTypes.NOTIFY_CUSTOMER_CHANNELS, data);
                this.notifyCustomerProcess(data)
              })
            });
          },
        },
        watch: {
            interval(val) {
                let get_statistic = false
                switch (val) {
                    case '30days':
                        this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    case '90days':
                        this.fromDate = moment().subtract(89, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    default:
                        break
                }
                if (get_statistic) {
                    this.getCrmData()
                }

            },
            pagination: {
              handler() {
                  this.getCrmData()
              }
            },
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    this.getListChannels()
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                        this.connectNotiChannelsOfBot(bot.code)
                    }
                }
            },
            notifyBotChat(val) {
                if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.SESSION_REPORT_STATUS) {
                    if (val.data.is_success) {
                        this.$AppService.toastSuccess(this.$t("excelsReportSuccess"))
                    }
                    else {
                        this.$AppService.handleRequestError(this.$t("excelsReportFailed"))
                    }
                    this.is_lock_report = false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
    .modal .container{
        padding: 1px;
    }
    .overlay {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    }

    .modal {
    position:absolute;
    margin:0 auto;
    left:0;
    right:0;
    top:20%;
    width:100%;
    max-width:40%;
    height:520px;
    background-color:#fff;
    z-index: 9999;
    padding:20px;

    max-height:520px
    }

    .close{
    position: absolute;
    top: 10px;
    right: 10px;
    }

    ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 300px;
    }

    input {
    margin-right: .5em;
    }
    div.scroll {
        margin:4px, 4px;
        padding:4px;
        width: 600px;
        height: 400px;
        z-index: 9999;
        overflow-x: hidden;
        overflow-y: auto;
        text-align:justify;
    }
    .filter {
        display: flex;
        flex-wrap: wrap;
    }
    .filter>* {
        flex: 0 0 20%;
        padding-left : 0.5% !important;
        padding-right: 0.5% !important;
    }
    /* Create two equal columns that floats next to each other */
    .custom-column {
    float: left;
    width: 50%;
    padding: 10px;
    height: 100%; /* Should be removed. Only for demonstration */
    }

    /* Clear floats after the columns */
    .custom-row:after {
    content: "";
    display: table;
    clear: both;
    }
    .container-checkbox {
    display: block;
    position: relative;
    padding-left: 0px;
    padding-bottom: 15px;
    cursor: pointer;
    font-size: 15px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .container-checkbox:hover input ~ .checkmark {
    background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container-checkbox input:checked ~ .checkmark {
    background-color: #4977ee;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    }

    /* Show the checkmark when checked */
    .container-checkbox input:checked ~ .checkmark:after {
    display: block;
    }

    /* Style the checkmark/indicator */
    .container-checkbox .checkmark:after {
    left: 7px;
    top: 3px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    }
    #rcorners {
    border-radius: 7px;
    border: 2px solid #4977ee;
    padding: 20px;

    }
    .table {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    border-collapse: collapse;
    width: 100%;
    }

    .table td,
    .table th {
    border: 1px solid #ddd;
    padding: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    font-size: 15px;
    }
    .table thead th {
    border: 1px solid #ddd;
    padding: 4px;
    padding-top: 6px;
    padding-bottom: 5px;
    text-align: center;
    font-size: 15px;
    }
    .table .container-checkbox {
        float: center;
    }
    table.table tbody tr.selected {
    background-color: #f2f2f2;
    }
    .table th{
        background-color: #4977ee;
        color: white;
        z-index: 99;
        text-align: center;

    }
    .table tr:hover {
    background-color: #ddd !important;
    }

      .tableFixHead {
        overflow-y: auto; /* make the table scrollable if height is more than 200 px  */
        height: 350px; /* gives an initial height of 200px to the table */
      }
      .tableFixHead thead th {
        position: sticky; /* make the table heads sticky */
        top: 0px; /* table head will be placed from the top of the table and sticks to it */
      }

</style>
